<!-- Loading.vue -->
<template>
  <div
    v-if="isLoading"
    class="loading-overlay"
  >
    <img
      src="../../../../public/img/icons/loading.gif"
      alt="Loading"
    >
  </div>
</template>

<script>
export default {
  props: {
    isLoading: Boolean
  }
}
</script>
